var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"quill",attrs:{"options":_vm.editorOption},model:{value:(_vm.value.ApplicationText),callback:function ($$v) {_vm.$set(_vm.value, "ApplicationText", $$v)},expression:"value.ApplicationText"}})}
var staticRenderFns = []

export { render, staticRenderFns }